export const hash = '30321c5e-b2ca-4471-9d35-ce3940278974';

// export const gateKey = '';
export const gateKey = 'ek_live_g5Df6bp6y5ptAKeOVOpBloZHmqY0sb';
export const recaptchaKey = '6LdoQWIeAAAAAP457cno1Yt_wU6F2dbJxz-M_vCY';
export const apiUrl = `https://api-global-v3.encontrodigital.com.br/${hash}`;
export const apiSocket = 'https://socket-2023.encontrodigital.com.br/';
//export const apiSocket = 'http://localhost:8001';

//export const apiUrl = `http://localhost:8000/${hash}`;
export const defaultProjectHash = '';
export const urlWebsite = 'https://portal-hipertensao.encontrodigital.com.br';
export const supportNumber = `555195181533`;
export const home = 'Home';
export const haveTranslate = false;
// export const urlWebsite = 'http://localhost:3000';
export const eventName = 'Portal Hipertensão';
export const logo = '/assets/logo.png';
export const background = '/assets/evento/Fundo.jpeg';
export const authTitle = 'Portal Hipertensão';
export const dadosOrganizacao = '';
export const social = {
  whatsapp: '5551981642021',
  instagram: 'hipertensao_portal/',
  facebook: 'HipertensaoPortal/',
  linkedin: 'company/hipertens%C3%A3o-portal/',
  youtube: '',
  twitter: '',
  website: ''
};


export const defaultTheme = {
  defaultBackground: 'rgb(0,50,150)',
  defaultColor: '#fff',
  logo: {
    minWidth: '450px',
  },
  menu: {
    background: 'none',
    backgroundSticky: 'none',
    backgroundMobile: 'rgb(0,50,150)',
    color: '#fff',
    shadow: '0',
    logoColor: 'none',
  },
};

export const getToken = (): string | null => {
  const token = localStorage.getItem(`@${authTitle}:token`);
  return token;
};
